const zIndex = {
  min: 1,
  backdrop: 1,
  offerFilters: 2,
  stickyHeaderBanner: 2,
  reviewCartButtons: 3,
  floatingBookmarkButton: 3,
  searchSubMenu: 4,
  searchMenu: 5,
  tooltip: 10,
  tripSupport: 15,
  stickyFooter: 20,
  stickyFooterMultiRoom: 21,
  stickySubHeader: 99,
  stickyHeader: 100,
  stickyPromptCard: 101,
  appBottomNav: 102,
  floatingPanel: 104,
  header: 104,
  menu: 105,
  draggingItem: 106,
  spoofingWarning: 299,
  modal: 300,
  menuInModal: 301,
  notification: 301,
} as const

export default zIndex
